export default {
  // Frontend errors
  generic: 'Ha ocurrido un error',
  noResults: 'Sin resultados',

  // Web3 errors
  challengeNotSigned: 'Demostración de tenencia no firmada',
  couldntRetrieveHRContentURI: 'No se pudo obtener enlace al contenido de alta resolución',
  fetchingContractData: 'Error al obtener datos del contrato',
  fetchingTokensData: 'Error al obtener datos de los tokens',
  fetchingTokenData: 'Error al obtener datos del token'

  // API errors
}
